import jQuery from 'jquery';

/**
 * --------------------------------------------------------------------------
 * Snippet
 * --------------------------------------------------------------------------
 */

const snippet = ($ => {

	/**
	 * ------------------------------------------------------------------------
	 * Constants
	 * ------------------------------------------------------------------------
	 */

	const NAME = 'snippet';
	const JQUERY_NO_CONFLICT = $.fn[NAME];

	/**
	 * ------------------------------------------------------------------------
	 * Class Definition
	 * ------------------------------------------------------------------------
	 */

	class Snippet {

		static jQueryInterface(config) {

			if (config === 'equalize') {
				const rows = [];
				let prev = null;
				this.each(function () {
					if (prev && $(this).position().top === $(prev).position().top) {
						rows[rows.length - 1].push(this);
					}else {
						rows.push([this]);
					}
					prev = this;
				});
				rows.forEach(row => {
					if (row.length === 1) {
						return;
					}
					const result = row.every(element => {
						const $price = $(element).find('.snippet__price-new');
						const $buttons = $(element).find('.snippet__buttons');
						let equal = true;
						if ($price.length > 0 && $buttons.length > 0) {
							equal = $price.position().top === $buttons.position().top;
						}
						return equal;
					});
					if (!result) {
						row.forEach(element => {
							$(element).find('.snippet__price-new').css('width', '100%');
						});
					}
				});
				return this;
			}

			// return this.each(function () {
			// 	let $element = $(this)
			// 	let data = $element.data(DATA_KEY)

			// 	if (!data) {
			// 		data = new Snippet(this)
			// 		$element.data(DATA_KEY, data)
			// 	}

			// })
		}

	}

	/**
	 * ------------------------------------------------------------------------
	 * Data Api implementation
	 * ------------------------------------------------------------------------
	 */

	/**
	 * ------------------------------------------------------------------------
	 * jQuery
	 * ------------------------------------------------------------------------
	 */

	$.fn[NAME] = Snippet.jQueryInterface;
	$.fn[NAME].Constructor = Snippet;
	$.fn[NAME].noConflict = function () {
		$.fn[NAME] = JQUERY_NO_CONFLICT;
		return Snippet.jQueryInterface;
	};

	return Snippet;

})(jQuery);

export default snippet;



/** WEBPACK FOOTER **
 ** ./app/blocks/snippet/snippet.js
 **/